export const PostStatusOption = {
  Draft: `Draft`,
  Active: `Active`,
};
